module.exports = __webpack_public_path__ + "static/growme-dd153d0c1b3b8f42fdd2aeec244af3d1.jpg";